import React, { Fragment, useEffect, useState } from "react";
import Chart from "react-apexcharts";
import "./grafico.scss";

export default function Grafico({ graph, graphData }) {
  return graphData !== null ? (
    <Chart
      options={graphData.options}
      series={graphData.series}
      type="line"
      width="550"
    />
  ) : null;
}
